import { ISalesReportResponse } from '../../interfaces/sales-report.interface'
import { ILaborsReportResponse } from '../../interfaces/labors-report.interface'

export interface SalesReportsStateModel {
  reports: ISalesReportResponse
  laborsReports: ILaborsReportResponse
}
